import {
  ButtonChildrenPosition,
  ButtonContainer,
  getCoursesPath,
  getSearchEventData,
  handleClearFilters,
  IconTrashComponent,
  Nullable,
  pushDataLayer,
  QueryParams,
  SearchEventNames,
  urlService,
  useTheme,
  useTranslations,
} from '@lerna-core';
import React, { ReactElement } from 'react';
import { EmptyClearButtonStyled } from './emptyClearButton.styled';
import { FiltersClearAllContainer } from '@features/common/filters';
import { rgba } from 'polished';
import { useCoursesByTitleContext } from '@features/courses';
import { ParsedUrlQuery } from 'querystring';
import { useRouter } from 'next/router';
import { useAppDispatch } from '@store/store.hooks';

export const EmptyClearButtonContainer = (): Nullable<ReactElement> => {
  const theme = useTheme();
  const router = useRouter();
  const dispatch = useAppDispatch();
  const translations = useTranslations();
  const coursesByTitle = useCoursesByTitleContext();

  const handleClear = () => {
    if (coursesByTitle.meta.total > 0) {
      pushDataLayer(getSearchEventData(SearchEventNames.searchReset));
    }
  };

  const handleClearAction = () => {
    const defaultPathname = getCoursesPath(router.query);
    const query: ParsedUrlQuery = {
      title: router.query[QueryParams.title],
    };
    if (router.query[QueryParams.promoCode]) {
      query[QueryParams.promoCode] = router.query[QueryParams.promoCode];
    }
    dispatch(handleClearFilters());

    router.push(
      urlService.createUrlFromPathAndQuery(defaultPathname, router, query),
      undefined,
      { scroll: true }
    );
  };

  return (
    <EmptyClearButtonStyled>
      <FiltersClearAllContainer
        handleClearAction={
          coursesByTitle.meta.total > 0 ? handleClearAction : undefined
        }
        handleClear={handleClear}
      >
        <ButtonContainer
          additionalColors={{
            color: theme.COLOR.WHITE,
            backgroundColor: '#333333',
            backgroundHoverColor: rgba('#333333', 0.8),
          }}
          title={translations.clear_filters}
          borderRadius={100}
          children={<IconTrashComponent />}
          childrenPosition={ButtonChildrenPosition.left}
        />
      </FiltersClearAllContainer>
    </EmptyClearButtonStyled>
  );
};
